import UpsellBanner from 'components/Common/UpsellBanner'
import type { FlightsClassTypes } from 'constants/flight'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import useAirportSearch from 'hooks/Flights/useAirportSearch'
import useFlightDeals from 'hooks/Flights/useFlightDeals'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { sortBy } from 'lib/array/arrayUtils'
import React, { useCallback, useMemo } from 'react'
import { useIntl } from 'react-intl'

interface Props {
  originAirportCode: string
  destinationAirportCode: string
  offer?: App.BedbankOffer
}

function BedbankOfferFlightDealBanner(props: Props) {
  const intl = useIntl()
  const {
    destinationAirportCode,
    originAirportCode,
    offer,
  } = props

  const [deals] = useFlightDeals('all', {
    originAirportCode,
    destinationAirportCode,
  })

  const dispatch = useOfferPageDispatch()
  const [airportSearchResults] = useAirportSearch(destinationAirportCode)

  const activeDeal = useMemo(() => {
    return sortBy(deals, (deal) => deal.perAdultPrice, 'asc')[0]
  }, [deals])

  const locationCaption = useMemo(() => {
    const destinationAirport = airportSearchResults.find((airport) => airport.airportCode === destinationAirportCode)

    if (!destinationAirport) {
      return offer?.property.locationTitleOverride || offer?.property.address.city || ''
    }

    return intl.formatMessage(
      {
        id: 'FS5SISbk-JtLz5uzmWaS',
        defaultMessage: '{cityDesc} ({airportName} - {airportCode})',
        description: 'Destination city with airport name and code in bedbank flight deal banner',
      },
      { cityDesc: destinationAirport.cityDesc, airportName: destinationAirport.airportName, airportCode: destinationAirport.airportCode },
    )
  }, [airportSearchResults, destinationAirportCode, offer?.property, intl])

  const handleCheckAvailability = useCallback(() => {
    dispatch({ type: OfferPageActions.toggleFilter, filter: 'checkin' })
    dispatch({ type: OfferPageActions.setFlights, flights: true })
  }, [dispatch])

  if (!activeDeal) {
    return null
  }

  return (
    <UpsellBanner
      carrierLogo={activeDeal.carrier.logo?.url}
      carrierName={activeDeal.carrier.name}
      destinationName={locationCaption}
      price={activeDeal.perAdultPrice}
      onCheckAvailability={handleCheckAvailability}
      fareType={activeDeal.fareType}
      fareClass={activeDeal.fareClass as FlightsClassTypes}
    />
  )
}

export default withOfferPageAndReduxState((state) => ({
  offer: state.bedbankOffer,
}), BedbankOfferFlightDealBanner)
